export const site_url='https://mkbmaligai.in/api';
export const site_url_img='https://mkbmaligai.in/public/storage';
export const invoice_img='assets/img/invoice.png';
export const nodata='assets/ZLoYNL4NvA.json';
export const truck='assets/img/delivery-truck.png';

